import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel } from "react-icons/ai";
import { IoReturnDownForward } from "react-icons/io5";
import {
  Container,
  Row,
  Col,
  Nav,
  Button,
  Modal,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { FaRegFile, FaRegSave } from "react-icons/fa";
import autoTable from "jspdf-autotable";
import KpiService from "../../Services/KpiService";
import {
  allowNumberswithMaxLengthcatidtypeOnly,
  allowNumberswithMaxLengthtypeOnly,
  convertFormattedToPlainNumber,
  denomallowNumberswithMaxLengthtypeOnly,
  exportToentryExcel,
  formatNumberIndianWithDecimal,
  generateentryPdf,
  isFY2025OrLater,
} from "../utils/commonFunctions";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
// import ReactTooltip from "react-tooltip";
export default function KpiIndicatorEntryHod() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [yearlist, setYearlist] = useState();
  const [categorylist, setCategorylist] = useState();
  const [Id, setId] = useState();
  const [Periodicid, setperiodicId] = useState(); const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [sequenceId, setSequenceId] = useState(); const [roleeid, setRoleeid] = useState(); const [addModal, setAddModal] = useState(); const [fieldenb, setFieldenb] = useState(false); const [showModal, setShowModal] = useState(false); const [workFlow, setWorkFlow] = useState([]);
  const [data, setData] = useState(null);
  const [deptlist, setDeptlist] = useState([]);
  let deptId = localStorage.getItem("deptid");
  let mandal = localStorage.getItem("mandalid");
  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("role");
  let district = localStorage.getItem("districtid");

  const formik = useFormik({
    initialValues: {
      userId: "",
      district_id: "",
      mandal_id: "",
      periodic_id: "",
      department_id: "",
      year: "",
      date: "",
      Indicators: [
        {
          status_id: "",
          ind_type: "",
          indicator_id: "",
          entry_value: "",
          iszero: "",
          numerator: "",
          denominator: "",
          multiplir: "",
          unit_cat_id: "",
          columns: "",
          maxLength: "",
          type: "",
          unit: "",
          sno: "",
          targets_2025: "",
          targetenb: false,
          ind_phase: "",
          economicRemarks: "",
          consolidatedRemarks: "",
        },
      ],
      remarks: "",
    },
    onSubmit: (values) => { },
  });

  React.useEffect(() => {
    formik.setFieldValue("district_id", district !== "0" ? district : "");
    formik.setFieldValue(
      "mandal_id",
      mandal !== "0" && mandal !== "00" ? mandal : "",
    );
  }, []);
  const periodicityMap = { monthly: { label: "MONTHLY", value: "6" }, quarterly: { label: "QUARTERLY", value: "7" }, half_yearly: { label: "HALFYEARLY", value: "5" }, annually: { label: "ANNUALLY", value: "3" }, bi_annual: { label: "BIENNIAL", value: "8" }, five_years: { label: "FIVE-YEARS", value: "2" }, };

  useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" });
    if (roleid !== "8") {
      let paramss = { userId: username, deptId: deptId, mandal: "No", district: "No", state: "Yes", secretariat: "No", };
      KpiService.getperiodicityStatusForAchievementsEntry(paramss).then(
        (res) => {
          if (res.data.SCODE === "01") { setData(res.data.SDESC[0]); setPeriodiclistenb(true); } else { showAlertMessage(res.data.SDESC, "warning"); setPeriodiclistenb(false); }
        },
      );
    }
    if (roleid === "8") {
      let paramss = { userId: username };
      MasterService.getDeptartments(paramss).then((res) => {
        if (res.data) {
          let options = res.data?.SDESC.map((item, i) => {
            return (<option key={i} value={item.dept_id}> {" "} {item.dept_name}{" "} </option>);
          });
          setDeptlist(options);
        }
      });
    } store.dispatch({ type: "HIDE_SPINNER" });
  }, []);
  useEffect(() => {
    formik.values?.Indicators?.forEach((item, i) => {
      if (item.columns === 3) {
        if (!item.numerator || !item.denominator) {
          formik.setFieldValue(`Indicators.${i}.entry_value`, "");
        } else if (item.denominator !== 0) {
          const multiplier = item.multiplir; const devider = item.devider; const mainval = multiplier
            ? ((parseFloat(item.numerator) / parseFloat(item.denominator)) * parseInt(item.multiplir)).toFixed(3)
            : multiplier === "" && devider ? (parseFloat(item.numerator) / parseFloat(item.denominator) / parseInt(item.devider)).toFixed(3)
              : (parseFloat(item.numerator) / parseFloat(item.denominator)).toFixed(3);
          formik.setFieldValue(`Indicators.${i}.entry_value`, isFinite(mainval) ? mainval : "0.000",);
        }
      }
      if (item.columns === 4) {
        if (!item.numerator || !item.denominator) {
          formik.setFieldValue(`Indicators.${i}.entry_value`, "");
        } else if (item.denominator !== 0) {
          const multiplier = item.multiplir;
          const devider = item.devider;
          const mainval = multiplier
            ? (((parseFloat(item.numerator) - parseFloat(item.denominator)) / parseFloat(item.denominator)) * parseInt(item.multiplir)).toFixed(3)
            : multiplier === "" && devider ? ((parseFloat(item.numerator) - parseFloat(item.denominator)) / parseFloat(item.denominator) / parseInt(item.devider)).toFixed(3)
              : (parseFloat(item.numerator) / parseFloat(item.denominator)).toFixed(3);
          formik.setFieldValue(`Indicators.${i}.entry_value`, isFinite(mainval) ? mainval : "0.000",);
        }
      }
    });
  }, [formik.values.Indicators]);

  // useEffect(() => { const handleScroll = () => { ReactTooltip.hide(); }; window.addEventListener("scroll", handleScroll); return () => { window.removeEventListener("scroll", handleScroll); }; }, []);

  const YearData = (e) => {
    setYearlist([]);
    setperiodicId(e.target.value);
    setId("");
    formik.setFieldValue("date", "");
    formik.setFieldValue("year", "");
    formik.setFieldValue("category", "");
    setEntrydataEnb(false);
    if (!e.target.value) {
      return;
    }
    let params = { userId: username, periodicityId: e.target.value };
    KpiService.KpiperiodicYears(params).then((res20) => {
      let years = res20.data?.SDESC?.yearsList || [];
      // let res = res20.data?.SDESC?.headList === null && e.target.value !== "8" ? years.slice(1) : years;
      let res = years;
      if (res20.data) {
        let options = res.map((item, i) => {
          return (<option key={i} value={item.id}> {" "} {item.value}{" "} </option>);
        }); setYearlist(options);
      }
    }); setYearlist([]); setEntrydataEnb(false);
  };

  const Categorydata = (e) => {
    setEntrydataEnb(false); setCategorylist([]); formik.setFieldValue("category", ""); formik.setFieldValue("date", "");
    if (!e.target.value) {
      let missingFields = [];
      if (!e.target.value) missingFields.push("Year");
      const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`;
      showAlertMessage(errorMessage, "warning");
      setEntrydataEnb(false);
      return;
    }
    const selectedYear = e.target.value;
    setId(selectedYear);
    if (["1", "2", "3", "8"].includes(Periodicid)) {
      const params = {
        userId: username,
        districtId: "0",
        mandalId: "0",
        year: selectedYear,
        headId: "0",
        deptId: roleid === "8" ? formik.values.department_id : deptId,
        periodicityId: Periodicid,
        ulbId: "0",
      };
      fetchEntryData(params, selectedYear);
    } else {
      const params = { userId: username, periodicityId: Periodicid, year: e.target.value, };
      KpiService.kpiperiodicityMasterFutureDatesExtension(params).then(
        (res) => {
          const response = res.data.SDESC.headList;
          const options = response.map((item, i) => (<option key={i} value={item.id}> {" "} {item.value}{" "} </option>));
          setCategorylist(options);
        },);
    }
  };

  const checkVal = () => {
    if (!formik.values.remarks) {
      let missingFields = [];
      if (!formik.values.remarks) missingFields.push("Remarks");
      const errorMessage = "Please Enter Remarks";
      showAlertMessage(errorMessage, "warning");
      return;
    }
    setShowModal(true);
    setAddModal(false);
  };

  const getEntrydata = (e) => {
    if (!e.target.value) {
      let missingFields = [];
      if (!e.target.value) missingFields.push("Category");
      const errorMessage = `Please Select Required Field ${missingFields.join(", ")}.`;
      showAlertMessage(errorMessage, "warning");
      setEntrydataEnb(false);
      return;
    }
    const params = {
      userId: username,
      districtId: "0",
      mandalId: "0",
      year: Id,
      headId: e.target.value,
      deptId: roleid === "8" ? formik.values.department_id : deptId,
      periodicityId: Periodicid,
      ulbId: "0",
    };
    fetchEntryData(params, Id);
  };

  const Emptyfields = () => {
    formik.setFieldValue("periodic_id", "");
    formik.setFieldValue("year", "");
    formik.setFieldValue("category", "");
  };

  const [buttonenb, setButtonEnb] = useState();

  const fetchEntryData = (params, selectedYear) => {
    setSequenceId(null);
    formik.setFieldValue("Indicators", []);
    formik.values.Indicators.map((item, index) => {
      formik.setFieldValue(`Indicators[${index}].targetenb`, false);
    });
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.Kpientrydatahodlevel(params)
      .then((res) => {
        if (res.data.SCODE === "01") {
          setEntrydataEnb(true);
          setEntrydata(res.data.SDESC);
          setWorkFlow(res.data.getWorkFlow || []);
          let enb = true;
          res.data.SDESC.forEach((item, i) => {
            formik.setFieldValue(
              `Indicators[${i}].entry_value`,
              item.indicator_value === null ? "" : item.indicator_value,
            );
            // (() => { const raw = item.indicator_value; if (raw == null || raw === "") return ""; if (isNaN(raw)) return raw; const num = +raw; return Number.isInteger(num) ? num : Math.floor(num * 1000) / 1000; })() );
            formik.setFieldValue(
              `Indicators[${i}].indicator_id`,
              item.indicator_id === null ? "" : item.indicator_id,
            );
            formik.setFieldValue(
              `Indicators[${i}].columns`,
              item.no_of_columns === null ? "" : item.no_of_columns,
            );
            formik.setFieldValue(`Indicators[${i}].iszero`, item.iszero);
            formik.setFieldValue(
              `Indicators[${i}].maxLength`,
              item.max_length === null ? "" : item.max_length,
            );
            formik.setFieldValue(
              `Indicators[${i}].type`,
              item.rec_type === null ? "" : item.rec_type,
            );
            formik.setFieldValue(
              `Indicators[${i}].unit`,
              item.unit === null ? "" : item.unit,
            );
            formik.setFieldValue(
              `Indicators[${i}].numerator`,
              item.numerator === null ? "" : item.numerator,
            );
            formik.setFieldValue(
              `Indicators[${i}].unit_cat_id`,
              item.unit_cat_id === null ? "" : item.unit_cat_id,
            );
            formik.setFieldValue(
              `Indicators[${i}].targets_2025`,
              item.targets_2025 === null ? "" : item.targets_2025,
            );
            formik.setFieldValue(`Indicators[${i}].status_id`, item.status_id);
            formik.setFieldValue(`Indicators[${i}].ind_type`, item.ind_type);
            formik.setFieldValue(`Indicators[${i}].ind_phase`, item.ind_phase);
            formik.setFieldValue(
              `Indicators[${i}].economicRemarks`,
              item.maker_remarks,
            );

            if (isFY2025OrLater(selectedYear)) {
              {
                item.targets_2025 === null
                  ? formik.setFieldValue(`Indicators[${i}].targetenb`, true)
                  : formik.setFieldValue(`Indicators[${i}].targetenb`, false);
              }
            }
            formik.setFieldValue(
              `Indicators[${i}].multiplir`,
              item.multiplir === null ? "" : item.multiplir,
            );
            formik.setFieldValue(
              `Indicators[${i}].sno`,
              item.sno === null ? "" : item.sno,
            );
            formik.setFieldValue(
              `Indicators[${i}].devider`,
              item.devider === null ? "" : item.devider,
            );
            formik.setFieldValue(
              `Indicators[${i}].devider`,
              item.devider === null ? "" : item.devider,
            );
            formik.setFieldValue(
              `Indicators[${i}].dividend_type`,
              item.dividend_type === null ||
                item.dividend_type === undefined ||
                item.dividend_type === ""
                ? ""
                : item.dividend_type,
            );
            if (
              item.dividend_type !== null &&
              item.dividend_type !== undefined &&
              item.dividend_type !== ""
            ) {
              if (item.dividend_type === "Population") {
                formik.setFieldValue(
                  `Indicators[${i}].denominator`,
                  res.data?.population_data,
                );
              }
              if (item.dividend_type === "GSDP") {
                formik.setFieldValue(
                  `Indicators[${i}].denominator`,
                  res.data?.gsdp_data,
                );
              }
            } else {
              formik.setFieldValue(
                `Indicators[${i}].denominator`,
                item.denominator === null ? "" : item.denominator,
              );
            }
            if (item.sequence_id !== null) { setSequenceId(item.sequence_id); } if (item.targets_2025 !== null) { enb = false; }
          });
          if (isFY2025OrLater(selectedYear) && enb) { showAlertMessage("Entry is not allowed because target values have not yet been entered for all indicators.", "warning",); }
          const allIndicators = res.data.SDESC;
          const hasNtype = allIndicators.some((item) => item.ind_type === "N");

          let showButtons = false;
          if (isFY2025OrLater(selectedYear)) {
            const hasEditableTarget = allIndicators.some((item) => item.targets_2025 !== null && ![4].includes(item.status_id),);
            const allNoTargets = allIndicators.every((item) => item.targets_2025 === null,);

            if (allNoTargets) { showButtons = false; } else if (hasEditableTarget) { showButtons = true; } else { showButtons = false; }
          } else {
            if (hasNtype) {
              // Show buttons if any N type indicator has status_id 0 or 1
              if (
                allIndicators.some(
                  (item) =>
                    item.ind_type === "N" && [0, 1].includes(item.status_id),
                )
              ) {
                showButtons = true;
              } else {
                showButtons = false;
              }
            } else {
              // Only O type indicators
              if (
                allIndicators.some(
                  (item) =>
                    item.ind_type === "O" && [4].includes(item.status_id),
                )
              ) {
                showButtons = false;
              } else {
                showButtons = true;
              }
            }
          }
          // Apply final visibility state
          setButtonEnb(showButtons); // or replace with your existing state setter like setNewincenb()
          console.log("Button visibility:", showButtons);
        } else {
          setEntrydata([]);
          setEntrydataEnb(false);
          showAlertMessage(res.data.SDESC, "warning");
        }
        if (res.data.SCODE != "02") {
          if (res.data.statusCheck.length === 0) {
            setRoleeid("0");
          } else {
            if (
              Array.isArray(res.data.statusCheck) &&
              res.data.statusCheck.length > 0
            ) {
              setRoleeid(res.data.statusCheck[0].role_id);
            }
          }
          setFieldenb(
            res.data.statusCheck.length === 0
              ? false
              : res.data.statusCheck[0].role_id === 200
                ? true
                : false,
          );
        }
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };
  let hasOldStatus = false;
  hasOldStatus = formik.values.Indicators.some((ind) =>
    [4].includes(ind.status_id),
  );
  const denominatorchange = (index, unit_cat_id) => {
    console.log(
      "formik.values.Indicators[i]?.entry_value",
      formik.values.Indicators[index]?.entry_value,
    );
    if (
      formik.values.Indicators[index]?.entry_value > parseFloat(100) &&
      [2, 9, 11].includes(unit_cat_id)
    ) {
      showAlertMessage(
        "Achieved Value Exceeded 100%. Kindly check it.",
        "warning",
      );
    }
  };

  const validatefieldvalues = () => {
    let enb = false; { formik.values?.Indicators?.forEach((item, i) => {
        if (item.columns === 3 || item.columns === 4) {
          if (!item.numerator && item.denominator) { showAlertMessage(`Please Enter Numerator!`, "warning"); enb = true; }
          if (item.numerator && !item.denominator) { showAlertMessage(`Please Enter Denominator!`, "warning"); enb = true; }
        } }); }
    return enb;
  };

  const handleInputChange = (e, index, field, isZero) => {
    const rawValue = e.target.value.trim();
    if (rawValue === "-") {
      showAlertMessage(
        "Please enter a valid number, not just '-'.",
        "warning",
        () => {
          formik.setFieldValue(`Indicators[${index}].${field}`, "");
        },
      );
      return;
    }
    const sanitizedValue = rawValue.replace(/,/g, "");
    const numericValue = parseFloat(sanitizedValue);
    const isDenominator = field === "denominator";
    if (isDenominator) {
      if (numericValue <= "0" && !["0", "-1"].includes(isZero)) { showAlertMessage("Denominator must be a positive number", "warning", () => { formik.setFieldValue(`Indicators[${index}].${field}`, ""); },); return; }
    } else {
      if (numericValue == "0" && isZero == "1") { showAlertMessage("Only positive Numbers are allowed for this indicator", "warning", () => { formik.setFieldValue(`Indicators[${index}].${field}`, ""); },); return; }
      if (numericValue == "0" && !["0", "-1"].includes(isZero)) { showAlertMessage("Zero is not allowed for this indicator", "warning", () => { formik.setFieldValue(`Indicators[${index}].${field}`, ""); },); return; }

      if (numericValue < "0" && isZero !== "-1") { showAlertMessage("Negative values are not allowed for this indicator", "warning", () => { formik.setFieldValue(`Indicators[${index}].${field}`, ""); },); return; }
    }

    formik.setFieldValue(`Indicators[${index}].${field}`, rawValue);
  };

  const restrictToPasteOnlyEightDotThreeAllowKeyPress = (
    formik,
    fieldName,
    index,
  ) => ({
    onPaste: (e) => {
      e.preventDefault();
      const pasted = e.clipboardData.getData("text").trim();
      const regex = /^\d{1,8}(\.\d{1,3})?$/;
      if (regex.test(pasted)) {
        formik.setFieldValue(`Indicators[${index}].${fieldName}`, pasted);
      } else {
        showAlertMessage(
          "Only Positive numbers with up to 8 digits before the decimal point and up to 3 digits after the decimal point are allowed. ",
          "warning",
        );
      }
    },
  });

  const restrictToPasteEightDotThreeHandler = (formik, fieldName, index, isAllowedNegative, unit_cat_id,) => ({
    onPaste: (e) => {e.preventDefault();  const pasted = e.clipboardData.getData("text").trim();
      if (pasted === "-") { showAlertMessage("Please enter a valid number, not just '-'.", "warning",); return; }
      if (unit_cat_id !== 1 && pasted.includes(",")) { showAlertMessage("Commas are not allowed in this field.", "warning"); return; }
      const cleanValue = pasted.replace(/,/g, ""); const numericValue = parseFloat(cleanValue); const isNumeric = !isNaN(numericValue); const baseRegex = /^-?\d{1,8}(\.\d{1,3})?$/; if (!baseRegex.test(cleanValue)) { showAlertMessage("Only numbers with up to 8 digits before and 3 digits after the decimal point are allowed.", "warning",); return; }
      if (isNumeric) {
        const rule = `${isAllowedNegative}`.trim();

        if (rule === "null" || rule === "" || rule === "undefined" || isAllowedNegative == null) {
          if (numericValue <= 0) { showAlertMessage("Only positive numbers are allowed.", "warning"); return; }
        } else {
          switch (rule) {
            case "1":
              if (numericValue <= 0) { showAlertMessage( "Only positive numbers are allowed.", "warning", ); return; }
              break;
            case "0":
              if (numericValue < 0) { showAlertMessage( "Negative numbers are not allowed.", "warning", ); return; }
              break; case "-1": break; default:
              showAlertMessage( "Invalid configuration for number restrictions.", "warning", );
              return;
          }
        }
      }
      formik.setFieldValue(`Indicators[${index}].${fieldName}`, pasted);
    },
  });

  const SaveEntryData = () => {
    const hasAtLeastOneEntry = formik.values.Indicators?.some(
      (indicator) => String(indicator.entry_value || "").trim() !== "",
    );
    if (!hasAtLeastOneEntry) {
      showAlertMessage("At least one entry value must be provided.", "warning");
      return;
    }
    let enable = validatefieldvalues();
    if (enable) {
      return;
    }
    let stat = 1;
    formik.values.Indicators.map((item, index) => {
      if (item.status_id === 4) {
        stat = 4;
      }
    });
    let params = {
      type: "save",
      userId: username,
      ulbId: "0",
      dept_id: roleid === "8" ? formik.values.department_id : deptId,
      district_id: "0",
      mandal_id: "0",
      sequence_id: sequenceId,
      role_id: 60,
      periodicity_id: Periodicid,
      remarks: formik.values.remarks,
      year: formik.values.year || 0,
      head_id: formik.values.category || 0,
      indicaterEntryDto: [],
    };
    params.indicaterEntryDto = formik.values.Indicators.map((item, index) =>
      item.entry_value
        ? {
          indicator_id: item.indicator_id, unit: item.unit, indicatorType: item.ind_type, status_id: item.status_id, indicator_value: item.unit_cat_id === 13 ? item.entry_value : convertFormattedToPlainNumber(item.entry_value),
          numerator: convertFormattedToPlainNumber(item.numerator) || 0, denominator: convertFormattedToPlainNumber(item.denominator) || 0, makerRemarks: item.economicRemarks, consolidatedApproverRemark: item.economicRemarks,
        }
        : null,
    ).filter(Boolean);
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.SaveKpiMandalentryhodlevel(params)
      .then((res) => {
        if (res.data.SCODE === "01") {
          showAlertMessage(res.data.SDESC, "success", () => {
            const fetchParams = {
              userId: username,
              districtId: "0",
              mandalId: "0",
              year: formik.values.year,
              headId: formik.values.category || 0,
              deptId: roleid === "8" ? formik.values.department_id : deptId,
              periodicityId: formik.values.periodic_id,
              ulbId: "0",
            };

            fetchEntryData(fetchParams, formik.values.year);

          });
        } else {
          showAlertMessage(res.data.SDESC, "warning");
        }
      })
      .catch((err) => {
        showAlertMessage("Failed to save data. Please try again.", "warning");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };
  const handleClose = () => {
    setAddModal(false);
  };

  const validatevalue = () => { let val = false; formik.values.Indicators.map((item, index) => { if (item.entry_value) { val = true; } }); return val; };

  const validateConsolidatedRemarks = () => {
    const missing = [];

    formik.values.Indicators.forEach((item, index) => {
      const hasTarget = item.targets_2025 !== null && item.targets_2025 !== undefined && item.targets_2025 !== ""; const noRemark = !(item.economicRemarks ?? "").toString().trim();

      if (Number(item.ind_phase) === 4 && hasTarget && noRemark) { missing.push(index + 1); }
    });

    if (missing.length > 0) {
      showAlertMessage(`Please enter Maker Remarks for the indicator(s) at Sl.No. ${missing.join(", ")}.`, "warning",);
      return true;
    }
    return false;
  };

  const ApproveDatapopup = () => {
    const val = validatevalue(); if (!val) { showAlertMessage("At least one entry value must be provided.", "warning"); return; }
    let enable = validatefieldvalues(); if (enable) { return; }
    let missingEntries = [];
    formik.values.Indicators.forEach((item, index) => {
      if (item.targets_2025 !== null && item.targets_2025 !== "" && (item.entry_value === null || item.entry_value === "")) {
        missingEntries.push(`Indicator ${index + 1}`);
      }
    });
    if (missingEntries.length > 0) { showAlertMessage(`Please enter values for all indicators which have targets assigned.`, "warning",); return; }
    if (validateConsolidatedRemarks()) { return; } setAddModal(true);
  };
  const handleClosepop = () => { setShowModal(false); };
  const handleKeyDown = (e) => { if (e.key === "Enter" || e.key === "Escape") { e.preventDefault(); e.stopPropagation(); } };

  const ApproveData = () => {
    if (!formik.values.remarks) { let missingFields = []; if (!formik.values.remarks) missingFields.push("Remarks"); const errorMessage = "Please Enter Remarks"; showAlertMessage(errorMessage, "warning"); return; }
let params = { type: "approve", userId: username, ulbId: "0", dept_id: deptId, district_id: "0", mandal_id: "0", sequence_id: sequenceId, role_id: 200, periodicity_id: Periodicid, remarks: formik.values.remarks, year: formik.values.year, head_id: formik.values.category || 0, indicaterEntryDto: [], };

    params.indicaterEntryDto = formik.values.Indicators.map((item, index) =>
      item.entry_value
        ? {
          indicator_id: item.indicator_id, unit: item.unit, indicatorType: item.ind_type, status_id: item.status_id, indicator_value: item.unit_cat_id === 13 ? item.entry_value : convertFormattedToPlainNumber(item.entry_value),
          numerator: convertFormattedToPlainNumber(item.numerator) || 0, denominator: convertFormattedToPlainNumber(item.denominator) || 0, makerRemarks: item.economicRemarks, consolidatedApproverRemark: item.economicRemarks,
        } : null,
    ).filter(Boolean);
    setShowModal(false);
    setAddModal(false);
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.SaveKpiMandalentryhodlevel(params)
      .then((res) => {
        showAlertMessage(
          res.data.SDESC,
          res.data.SCODE === "01" ? "success" : "warning",
          () => {
            formik.setFieldValue("remarks", "");
            const fetchParams = {
              userId: username,
              districtId: "0",
              mandalId: "0",
              year: Id,
              headId: formik.values.category || 0,
              deptId: deptId,
              periodicityId: Periodicid,
              ulbId: "0",
            };
            fetchEntryData(fetchParams, formik.values.year);

          },
        );
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const [activePeriodicity, setActivePeriodicity] = useState("");
  useEffect(() => {
    if (data) {
      const firstKey = Object.entries(periodicityMap).find(
        ([key]) => data?.[key] > 0,
      );
      if (firstKey) {
        const { value } = firstKey[1];
        setActivePeriodicity(value);
        const syntheticEvent = { target: { name: "periodic_id", value } };
        YearData(syntheticEvent);
        formik.handleChange(syntheticEvent);
      }
    }
  }, [data]);
  const [periodiclistenb, setPeriodiclistenb] = useState(false);
  const perioicitylist = (e) => {
    setPeriodiclistenb(false);
    let paramss = { userId: username, deptId: e.target.value, mandal: "No", district: "No", state: "Yes", secretariat: "No", };
    KpiService.getperiodicityStatusForAchievementsEntry(paramss).then((res) => {
      if (res.data) {
        if (res.data.SCODE === "01") {
          setData(res.data.SDESC[0]); setPeriodiclistenb(true);
        } else {
          showAlertMessage(res.data.SDESC, "warning"); setPeriodiclistenb(false); setEntrydataEnb(false);
        }
      }
    });
  };

  return (
    <>
      {" "}
      <Menubar />{" "}
      <Container fluid style={{ width: "95%" }} className="map-header ">
        {" "}
        <div className="sa-title">
          {" "}
          <h2>
            {" "}
            Indicator <span> Entry -Hod Level</span>{" "}
          </h2>{" "}
        </div>{" "}
      </Container>
      <Container
        fluid
        style={{ width: "95%" }}
        className="mt-3 outer-page-content-container"
      >
        <FormikProvider value={formik}>
          {" "}
          <Form onSubmit={formik.handleSubmit}>
            {" "}
            <div className="mandal-container p-4">
              {" "}
              <Row>
                {roleid !== "8" && (
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select" >
                    {" "}
                    <label className="mb-1 fw-bold">
                      Secretariat Name
                    </label>{" "}
                    <Field className="mb-3 form-control" type="text" name="dept_name" value={localStorage.getItem("SectariatcodeName")} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }} />{" "}
                  </Col>
                )}
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select" > <label className="mb-1 fw-bold">HOD Name</label>

                  {roleid === "8" ? (
                    <Field component="select" name="department_id" className="mb-3 form-control" onChange={(e) => { Emptyfields(); formik.handleChange(e); perioicitylist(e); }} style={{ fontWeight: "bold" }} disabled={ deptId === "179" || roleid === "8" ? false : true } >
                      {" "}
                      <option value="">--Select--</option> {deptlist}{" "}
                    </Field>
                  ) : (
                    <Field className="mb-3 form-control" type="text" name="dept_name" value={localStorage.getItem("deptcodeName")} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }} />
                  )}
                </Col>
              </Row>
            </div>
            {periodiclistenb && (
              <>
                <div className="tabs-top">
                  <Nav variant="pills" className="tabs-row d-flex flex-wrap justify-content-start gap-1 mb-2 mt-4" >
                    {Object.entries(periodicityMap)
                      .filter(([key]) => data?.[key] > 0)
                      .map(([key, { label, value }]) => (
                        <div key={key} className="flex-grow-1 flex-shrink-0" style={{ maxWidth: "120px" }} >
                          <Nav.Item className="tab-boxes-small">
                            {" "}
                            <Nav.Link
                              eventKey={value}
                              onClick={() => {
                                const syntheticEvent = {
                                  target: { name: "periodic_id", value },
                                };
                                setActivePeriodicity(value);
                                YearData(syntheticEvent);
                                formik.handleChange(syntheticEvent);
                                formik.setFieldValue("Indicators", []);
                              }}
                              active={activePeriodicity === value}
                              className="text-center"
                            >
                              {" "}
                              <p className="text-truncate text-center m-0">
                                {label}
                              </p>{" "}
                            </Nav.Link>{" "}
                          </Nav.Item>{" "}
                        </div>
                      ))}{" "}
                  </Nav>{" "}
                </div>
                <Row>
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select " style={{ marginLeft: "15px" }} >
                    {" "}
                    <label className="mb-1 fw-bold">Year</label>{" "}
                    <Field className="mb-3 form-control" component="select" name="year" controlId="formBasicEmail" onChange={(e) => { Categorydata(e); formik.handleChange(e); }} style={{ fontWeight: "bold" }} >
                      {" "}
                      <option value="">--Select--</option> {yearlist}{" "}
                    </Field>{" "}
                  </Col>
                  {(Periodicid === "5" ||
                    Periodicid === "6" ||
                    Periodicid === "7") && (
                      <Col
                        xs={12}
                        sm={12}
                        lg={3}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mandal-select"
                      >
                        {" "}
                        <label className="mb-1 fw-bold">Category</label>{" "}
                        <Field
                          className="mb-3 form-control"
                          component="select"
                          name="category"
                          controlId="formBasicEmail"
                          style={{ fontWeight: "bold" }}
                          onChange={(e) => {
                            getEntrydata(e);
                            formik.handleChange(e);
                          }}
                        >
                          {" "}
                          <option value="">--Select--</option> {categorylist}{" "}
                        </Field>{" "}
                      </Col>
                    )}{" "}
                </Row>
              </>
            )}
            {entrydataEnb && (
              <Row className="mt-3">
                <Col xxl={9} xl={9} lg={9} md={12} sm={12} xs={12} className="">
                  <Button
                    variant="danger"
                    size="sm"
                    className="btn mx-2 mt-2 mb-1 pdf-btn"
                    style={{ float: "right", marginLeft: "3px" }}
                    onClick={() =>
                      generateentryPdf( "my-table", formik.values, "KpiIndicatorHodEntry", )
                    }
                  >
                    {" "}
                    PDF <MdOutlinePictureAsPdf />{" "}
                  </Button>
                  <Button
                    variant="success"
                    size="sm"
                    className="btn mx-2 mt-2 mb-1 excel-btn"
                    style={{
                      float: "right",
                      color: "#ffffff",
                      marginLeft: "3px",
                    }}
                    onClick={() =>
                      exportToentryExcel(
                        "my-table",
                        formik.values,
                        "KpiIndicatorHodEntry",
                      )
                    }
                  >
                    {" "}
                    <span style={{ color: "green" }}>
                      {" "}
                      Excel{" "}
                      <AiFillFileExcel style={{ fontSize: "18px" }} />{" "}
                    </span>{" "}
                  </Button>

                  <div className="kp-indicatortable ">
                    <div
                      id="table-scroll"
                      className="mt-5 mb-5"
                      style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <table
                        className="table table-bordered custom-table table-responsive sticky-table"
                        id="my-table"
                      >
                        <thead style={{ borderRadius: "10px 10px 0px 0px" }}>
                          {" "}
                          <tr className="text-center"> {" "} <th className="sticky-col sticky-sno"> Sl.No. </th>{" "} <th className="sticky-col sticky-mandal"> INDICATOR </th>{" "} <th>UNIT</th>{" "}
                            <th style={{ width: "20%" }}> {" "} NUMERATOR/DENOMINATOR </th>{" "} <th> ACHIEVED VALUE</th>{" "}
                            {formik.values.Indicators?.some( (item) => Number(item.ind_phase) === 4, ) && <th>Remarks</th>}
                            {isFY2025OrLater(formik.values.year) && ( <th> {" "} TARGETS <br /> {formik.values.year} </th> )}{" "}
                          </tr>{" "}
                        </thead>
                        <tbody>
                          {EntryData?.length === 0 ||
                            EntryData?.length === undefined ? (
                            <tr>
                              {" "}
                              <td className="text-center" colSpan={ isFY2025OrLater(formik.values.year) ? "6" : "5" } >
                                {" "}
                                <b style={{ color: "red" }}>
                                  Details Not Found
                                </b>{" "}
                              </td>{" "}
                            </tr>
                          ) : (
                            (() => {
                              return EntryData?.map((detail, i) => {
                                return (
                                  <tr key={i}>
                                    <td
                                      style={{ textAlign: "center" }}
                                      className="sticky-col sticky-sno"
                                    >
                                      {" "}
                                      {i + 1}{" "}
                                    </td>
                                    <td
                                      sclassName="sticky-col sticky-mandal"
                                      style={{
                                        textAlign: "left",
                                        wordWrap: "break-word",
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      {detail.ind_type === "N" &&
                                        (isFY2025OrLater(formik.values.year)
                                          ? detail.targets_2025
                                          : {}) &&
                                        buttonenb &&
                                        [0, "0", null].includes(
                                          detail.status_id,
                                        ) && (
                                          <img
                                            src="../images/new3.gif"
                                            width="20px"
                                            alt="new"
                                            style={{ marginRight: "5px" }}
                                          />
                                        )}
                                      {detail.indicator_name}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {detail.unit_name}
                                    </td>

                                    <td className="text-right text-end">
                                      {detail.no_of_columns === 3 ||
                                        detail.no_of_columns === 4 ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                          }}
                                        >
                                          <Field
                                            autoComplete="off"
                                            name={`Indicators[${i}].numerator`}
                                            className="form-control"
                                            type="text"
                                            style={{ textAlign: "right" }}
                                            disabled={
                                              (formik.values.Indicators[i]
                                                .ind_type === "N" &&
                                                formik.values.Indicators[i]
                                                  .status_id === 4) ||
                                                (formik.values.Indicators[i]
                                                  .ind_type === "O" &&
                                                  hasOldStatus) ||
                                                formik.values.Indicators[i]
                                                  ?.targetenb
                                                ? true
                                                : false
                                            }
                                            onBlur={(e) => {
                                              handleInputChange(
                                                e,
                                                i,
                                                "numerator",
                                                formik.values.Indicators[i]
                                                  ?.iszero,
                                              );
                                              denominatorchange(
                                                i,
                                                detail.unit_cat_id,
                                              );
                                              formik.handleChange(e);
                                            }}
                                            onInput={(e) => {
                                              if (detail.unit_cat_id === 1) {
                                                allowNumberswithMaxLengthcatidtypeOnly(
                                                  e,
                                                  formik.values.Indicators[i]
                                                    ?.maxLength,
                                                  formik.values.Indicators[i]
                                                    ?.type,
                                                  3,
                                                  formik.values.Indicators[i]
                                                    ?.iszero,
                                                );
                                              } else {
                                                allowNumberswithMaxLengthtypeOnly(
                                                  e,
                                                  formik.values.Indicators[i]
                                                    ?.maxLength,
                                                  formik.values.Indicators[i]
                                                    ?.type,
                                                  3,
                                                  formik.values.Indicators[i]
                                                    ?.iszero,
                                                );
                                              }
                                            }}
                                            {...restrictToPasteEightDotThreeHandler(
                                              formik,
                                              "numerator",
                                              i,
                                              formik.values.Indicators[i]
                                                ?.iszero,
                                              detail.unit_cat_id,
                                            )}
                                          />
                                          <span style={{ fontSize: "15px" }}>
                                            /
                                          </span>
                                          <Field
                                            autoComplete="off"
                                            name={`Indicators[${i}].denominator`}
                                            className="form-control"
                                            onBlur={(e) => {
                                              handleInputChange(
                                                e,
                                                i,
                                                "denominator",
                                                formik.values.Indicators[i]
                                                  ?.iszero,
                                              );
                                              denominatorchange(
                                                i,
                                                detail.unit_cat_id,
                                              );
                                              formik.handleChange(e);
                                            }}
                                            type="text"
                                            style={{ textAlign: "right" }}
                                            disabled={
                                              (formik.values.Indicators[i]
                                                .ind_type === "N" &&
                                                formik.values.Indicators[i]
                                                  .status_id === 4) ||
                                              (formik.values.Indicators[i]
                                                .ind_type === "O" &&
                                                hasOldStatus) ||
                                              (detail.dividend_type !== null &&
                                                detail.dividend_type !==
                                                undefined &&
                                                detail.dividend_type !== "") ||
                                              formik.values.Indicators[i]
                                                ?.targetenb
                                            }
                                            onInput={(e) => {
                                              denomallowNumberswithMaxLengthtypeOnly(
                                                e,
                                                formik.values.Indicators[i]
                                                  ?.maxLength,
                                                formik.values.Indicators[i]
                                                  ?.type,
                                                3,
                                              );
                                            }}
                                            {...restrictToPasteOnlyEightDotThreeAllowKeyPress(
                                              formik,
                                              "denominator",
                                              i,
                                            )}
                                          />
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </td>

                                    <>
                                      <td className="text-right text-end ">
                                        <div className="d-flex align-items-center">
                                          {detail.unit_cat_id !== 13 ? (
                                            <Field
                                              autoComplete="off"
                                              className="form-control"
                                              name={`Indicators[${i}].entry_value`}
                                              value={
                                                detail.unit_cat_id === 1
                                                  ? formatNumberIndianWithDecimal(
                                                    formik.values.Indicators[
                                                      i
                                                    ]?.entry_value,
                                                  )
                                                  : formik.values.Indicators[i]
                                                    ?.entry_value
                                              }
                                              onBlur={(e) => { handleInputChange( e, i, "entry_value", formik.values.Indicators[i] ?.iszero, ); formik.handleChange(e); }}
                                              disabled={ ![1, 2].includes( detail.no_of_columns, ) || (formik.values.Indicators[i] .ind_type === "N" && formik.values.Indicators[i] .status_id === 4) || (formik.values.Indicators[i] .ind_type === "O" && hasOldStatus) || formik.values.Indicators[i] ?.targetenb ? true : false }
                                              type="text"
                                              style={{ textAlign: "right" }}
                                              onInput={(e) => {
                                                if (detail.unit_cat_id === 1) {
                                                  allowNumberswithMaxLengthcatidtypeOnly( e, formik.values.Indicators[i] ?.maxLength, formik.values.Indicators[i] ?.type, 3, formik.values.Indicators[i] ?.iszero, );
                                                } else {
                                                  allowNumberswithMaxLengthtypeOnly( e, formik.values.Indicators[i] ?.maxLength, formik.values.Indicators[i] ?.type, 3, formik.values.Indicators[i] ?.iszero, );
                                                }
                                              }}
                                              {...restrictToPasteEightDotThreeHandler(
                                                formik,
                                                "entry_value",
                                                i,
                                                formik.values.Indicators[i]
                                                  ?.iszero,
                                                detail.unit_cat_id,
                                              )}
                                            />
                                          ) : (
                                            <Field
                                              component="select"
                                              name={`Indicators[${i}].entry_value`}
                                              className="form-control mb-3"
                                              style={{ fontWeight: "bold" }}
                                              disabled={ ![1, 2].includes( detail.no_of_columns, ) || (formik.values.Indicators[i] .ind_type === "N" && formik.values.Indicators[i] .status_id === 4) || (formik.values.Indicators[i] .ind_type === "O" && hasOldStatus) || formik.values.Indicators[i] ?.targetenb ? true : false }
                                            >
                                              {" "} <option value=""> --Select-- </option>{" "} <option value="100"> TOP ACHIEVERS </option>{" "} <option value="75"> ACHIEVERS </option>{" "} <option value="50"> FAST MOVERS </option>{" "} <option value="25"> ASPIRERS </option>{" "}
                                            </Field>
                                          )}
                                          {detail.cal_formula && (
                                            <OverlayTrigger
                                              placement="top"
                                              trigger={["hover", "focus"]}
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-info-${detail.indicator_id}`}
                                                  className="custom-tooltipp"
                                                >
                                                  {" "}
                                                  <strong
                                                    style={{ fontSize: "18px" }}
                                                  >
                                                    Formula:{" "}
                                                  </strong>{" "}
                                                  <br />{" "}
                                                  {detail.cal_formula}{" "}
                                                </Tooltip>
                                              }
                                            >
                                              <span
                                                style={{
                                                  display: "inline-flex",
                                                }}
                                              >
                                                <img
                                                  src="images/info3.png"
                                                  alt="info"
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                    marginLeft: "10px",
                                                  }}
                                                  className="img-fluid"
                                                />{" "}
                                              </span>
                                            </OverlayTrigger>
                                          )}
                                          {/* {detail.cal_formula && ( <OverlayTrigger placement="top" trigger={["hover", "focus"]} container={typeof document !== 'undefined' ? document.body : undefined}
                                                overlay={<Tooltip id={`tooltip-info-${detail.indicator_id}`} className="custom-tooltipp"><strong style={{ fontSize: "18px" }}>Formula: </strong><br />{detail.cal_formula}</Tooltip>} >
                                                <img src="images/info3.png" alt="message" style={{ width: "20px", height: "20px", marginLeft: "10px" }} className="img-fluid" /> </OverlayTrigger> )}
                                                 */}
                                        </div>{" "}
                                      </td>{" "}
                                    </>
                                    {formik.values.Indicators?.some(
                                      (item) => Number(item.ind_phase) === 4,
                                    ) && (
                                        <td>
                                          {Number(
                                            formik.values.Indicators[i]
                                              ?.ind_phase,
                                          ) === 4 && (
                                              <Field
                                                as="textarea"
                                                name={`Indicators[${i}].economicRemarks`}
                                                className="form-control"
                                                disabled={
                                                  ![1, 2].includes(
                                                    detail.no_of_columns,
                                                  ) ||
                                                    (formik.values.Indicators[i]
                                                      .ind_type === "N" &&
                                                      [2, 4].includes(
                                                        formik.values.Indicators[i]
                                                          .status_id,
                                                      )) ||
                                                    (formik.values.Indicators[i]
                                                      .ind_type === "O" &&
                                                      hasOldStatus) ||
                                                    formik.values.Indicators[i]
                                                      ?.targetenb
                                                    ? true
                                                    : false
                                                }
                                              />
                                            )}
                                        </td>
                                      )}
                                    {isFY2025OrLater(formik.values.year) && ( <td className="text-right text-end "> {detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal( detail.targets_2025, ) : detail.targets_2025} </td> )}
                                  </tr>
                                );
                              });
                            })()
                          )}{" "}
                        </tbody>{" "}
                      </table>{" "}
                    </div>{" "}
                  </div>

                  {roleid == "8" ? (
                    <div className="bottom-buttons d-flex justify-content-center mb-5">
                      {" "}
                      {![200].includes(roleeid) && (
                        <Button
                          variant=""
                          size="sm"
                          className="save-btn  mx-4 mt-4"
                          onClick={() => SaveEntryData()}
                        >
                          {" "}
                          save <FaRegSave className="ms-1 s-icon" />{" "}
                        </Button>
                      )}{" "}
                    </div>
                  ) : (
                    <>
                      {buttonenb && (
                        <div className="bottom-buttons d-flex justify-content-center  mb-5">
                          <Button
                            variant=""
                            size="sm"
                            className="save-btn me-4"
                            onClick={() => SaveEntryData()}
                          >
                            {" "}
                            Save <FaRegSave className="ms-1 s-icon" />{" "}
                          </Button>
                          <Button
                            variant=""
                            size="sm"
                            className="next-btn me-4"
                            onClick={() => ApproveDatapopup()}
                          >
                            {" "}
                            Submit{" "}
                            <IoReturnDownForward
                              style={{ fontSize: "18px", marginLeft: "5px" }}
                            />{" "}
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                </Col>
                {workFlow.length !== 0 && (
                  <Col
                    xs={12}
                    sm={12}
                    md={6}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className="mt-5"
                  >
                    {" "}
                    <div className="card-all">
                      {" "}
                      <h2>Remarks</h2>{" "}
                      {workFlow?.map((item, index) => (
                        <>
                          {" "}
                          {item.remarks !== null ? (
                            <div key={index} className="card-info d-flex">
                              {" "}
                              <div className="user-icon-box">
                                {" "}
                                <div>
                                  {" "}
                                  <img
                                    src="images/message.webp"
                                    alt="message"
                                    className="img-fluid"
                                    style={{ marginRight: "5px" }}
                                  />{" "}
                                </div>{" "}
                              </div>{" "}
                              <div className="user-details">
                                {" "}
                                <div className="user-details-text">
                                  {" "}
                                  <h3>{item.remarks}</h3>{" "}
                                </div>{" "}
                              </div>{" "}
                            </div>
                          ) : (
                            ""
                          )}{" "}
                        </>
                      ))}{" "}
                    </div>{" "}
                  </Col>
                )}
              </Row>
            )}
            <Modal
              fade={false}
              className="newmodal"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={addModal}
            >
              <Modal.Header>
                {" "}
                <Modal.Title
                  className="text-center  fw-bold"
                  style={{
                    margin: "0 auto",
                    color: "black",
                    fontFamily: "'Times New Roman', Times, serif",
                  }}
                >
                  {" "}
                  Confirm & Approve{" "}
                </Modal.Title>{" "}
                <span
                  style={{
                    fontSize: "29px",
                    cursor: "pointer",
                    color: "black",
                  }}
                  onClick={handleClose}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") handleClose();
                  }}
                >
                  {" "}
                  &times;{" "}
                </span>{" "}
              </Modal.Header>
              <Modal.Body className="p-5">
                {" "}
                <Modal.Dialog className="internal">
                  {" "}
                  <Modal.Footer>
                    {" "}
                    Remarks <sup className="mandatort">*</sup>{" "}
                    <Field
                      as="textarea"
                      name="remarks"
                      rows={2}
                      cols={40}
                      style={{ resize: "none" }}
                      maxLength={200}
                    />{" "}
                  </Modal.Footer>{" "}
                </Modal.Dialog>{" "}
              </Modal.Body>
              <Modal.Footer>
                {" "}
                <button type="button" className="conform" onClick={checkVal}>
                  {" "}
                  Confirm <FaRegFile />{" "}
                </button>{" "}
              </Modal.Footer>
            </Modal>
            <Modal
              fade={false}
              className="newmodal"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showModal}
              onHide={null}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header>
                <Modal.Title></Modal.Title>
                <span
                  style={{
                    fontSize: "29px",
                    cursor: "pointer",
                    color: "black",
                  }}
                  onClick={handleClose}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") handleClose();
                  }}
                >
                  {" "}
                  &times;{" "}
                </span>
              </Modal.Header>
              <Modal.Body
                className="p-3 d-flex flex-column justify-content-center align-items-center"
                onKeyDown={handleKeyDown}
              >
                {" "}
                <div className="text-center">
                  {" "}
                  <img
                    src="images/question.gif"
                    style={{ width: "70px", marginBottom: "10px" }}
                    alt="Warning Icon"
                  />{" "}
                  <p className="fw-bold" style={{ fontSize: "17px" }}>
                    {" "}
                    Are you sure you want to Approve? Once Submitted no further
                    changes will be allowed.{" "}
                  </p>{" "}
                </div>{" "}
              </Modal.Body>
              <Modal.Footer>
                {" "}
                <button
                  type="button"
                  className="conform"
                  onClick={() => ApproveData()}
                >
                  {" "}
                  Yes{" "}
                </button>{" "}
                <button
                  type="button"
                  className="cancel"
                  onClick={handleClosepop}
                >
                  {" "}
                  No{" "}
                </button>{" "}
              </Modal.Footer>
            </Modal>{" "}
          </Form>{" "}
        </FormikProvider>{" "}
      </Container>{" "}
      <AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />{" "}
    </>
  );
}
